namespace RioERP.Reports {
    export interface ReferralOrderProductsForm {
        OrderId: Serenity.IntegerEditor;
        ProductId: Serenity.LookupEditor;
        Quantity: Serenity.IntegerEditor;
        Cost: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        DiscountAmt: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        SerialKey: Serenity.StringEditor;
        HasPendrive: Serenity.BooleanEditor;
        HasBooks: Serenity.BooleanEditor;
        HasCourier: Serenity.BooleanEditor;
        DownloadUrl1: Serenity.StringEditor;
        DownloadUrl2: Serenity.StringEditor;
        IsActive: Serenity.BooleanEditor;
        InvoiceCompanyId: Serenity.IntegerEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        FranchiseeDiscountValue: Serenity.DecimalEditor;
        EFranchiseeDiscountType: Serenity.IntegerEditor;
        EOpens: Serenity.IntegerEditor;
        EWatchTime: Serenity.IntegerEditor;
        EValidity: Serenity.IntegerEditor;
        EValidityType: Serenity.IntegerEditor;
        ValidTill: Serenity.DateEditor;
        TotalAllowedDuration: Serenity.IntegerEditor;
        AllowedDevices: Serenity.StringEditor;
        IsLive: Serenity.BooleanEditor;
        EAccessStatus: Serenity.IntegerEditor;
        IsTemplateSerialKey: Serenity.BooleanEditor;
        InsertUserId: Serenity.IntegerEditor;
        InsertDate: Serenity.DateEditor;
        UpdateUserId: Serenity.IntegerEditor;
        UpdateDate: Serenity.DateEditor;
        Note: Serenity.StringEditor;
        ESerialkeyStatus: Serenity.IntegerEditor;
        TaxAmount: Serenity.DecimalEditor;
        NetAmountAfterFrDiscount: Serenity.DecimalEditor;
        Category: Serenity.IntegerEditor;
        CartProductId: Serenity.IntegerEditor;
        SerialkeyType: Serenity.IntegerEditor;
        Rioplay8ProductCode: Serenity.StringEditor;
        Rioplay8ESubscriptionType: Serenity.IntegerEditor;
        Rioplay8EViewsType: Serenity.IntegerEditor;
        Rioplay8EWatchTimetype: Serenity.IntegerEditor;
        Rioplay8ViewsPerContent: Serenity.IntegerEditor;
        Rioplay8WatchTime: Serenity.DecimalEditor;
        Rioplay8AllowedDevices: Serenity.StringEditor;
        Rioplay8EDeviceRestrictionType: Serenity.IntegerEditor;
        Rioplay8DeviceCount: Serenity.IntegerEditor;
        Rioplay8SwitchCount: Serenity.IntegerEditor;
        Rioplay8ValidityInDays: Serenity.IntegerEditor;
        Rioplay8ValidDate: Serenity.DateEditor;
        Rioplay8TenantId: Serenity.StringEditor;
        ERioplayVersion: Serenity.IntegerEditor;
    }

    export class ReferralOrderProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.ReferralOrderProducts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReferralOrderProductsForm.init)  {
                ReferralOrderProductsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.StringEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.DateEditor;

                Q.initFormType(ReferralOrderProductsForm, [
                    'OrderId', w0,
                    'ProductId', w1,
                    'Quantity', w0,
                    'Cost', w2,
                    'GrossAmount', w2,
                    'DiscountAmt', w2,
                    'NetAmount', w2,
                    'TaxableAmount', w2,
                    'SerialKey', w3,
                    'HasPendrive', w4,
                    'HasBooks', w4,
                    'HasCourier', w4,
                    'DownloadUrl1', w3,
                    'DownloadUrl2', w3,
                    'IsActive', w4,
                    'InvoiceCompanyId', w0,
                    'FranchiseeDiscountAmount', w2,
                    'FranchiseeDiscountValue', w2,
                    'EFranchiseeDiscountType', w0,
                    'EOpens', w0,
                    'EWatchTime', w0,
                    'EValidity', w0,
                    'EValidityType', w0,
                    'ValidTill', w5,
                    'TotalAllowedDuration', w0,
                    'AllowedDevices', w3,
                    'IsLive', w4,
                    'EAccessStatus', w0,
                    'IsTemplateSerialKey', w4,
                    'InsertUserId', w0,
                    'InsertDate', w5,
                    'UpdateUserId', w0,
                    'UpdateDate', w5,
                    'Note', w3,
                    'ESerialkeyStatus', w0,
                    'TaxAmount', w2,
                    'NetAmountAfterFrDiscount', w2,
                    'Category', w0,
                    'CartProductId', w0,
                    'SerialkeyType', w0,
                    'Rioplay8ProductCode', w3,
                    'Rioplay8ESubscriptionType', w0,
                    'Rioplay8EViewsType', w0,
                    'Rioplay8EWatchTimetype', w0,
                    'Rioplay8ViewsPerContent', w0,
                    'Rioplay8WatchTime', w2,
                    'Rioplay8AllowedDevices', w3,
                    'Rioplay8EDeviceRestrictionType', w0,
                    'Rioplay8DeviceCount', w0,
                    'Rioplay8SwitchCount', w0,
                    'Rioplay8ValidityInDays', w0,
                    'Rioplay8ValidDate', w5,
                    'Rioplay8TenantId', w3,
                    'ERioplayVersion', w0
                ]);
            }
        }
    }
}
